import React from 'react';
import styled from 'styled-components';

import { media } from '../ui-components';
import { ExternalLink } from '../ui-components';

/**
 * Renders a section within a blog that fits multiple images and their titles
 *
 * @component MultiImageSection
 * 
 * @param {object} props
 * 
 * @prop {array} images
 * @prop {boolean} isPreview
 * 
 * @return {JSX}
 */
const MultiImageSection = props => {
  const { images, isPreview, onClickHandler } = props;

  const groupedImages = Object.keys(images).reduce((acc, key) => {
    if (key.includes('picture')) {
      let pictureIndex = key.split('picture').pop();

      acc.push({
        picture: isPreview
          ? images?.['picture' + pictureIndex]
            ? images?.['picture' + pictureIndex]?.fields?.file?.url
            : ''
          : images?.['picture' + pictureIndex]
          ? images?.['picture' + pictureIndex].url
          : '',
        caption: isPreview
          ? images?.['picture' + pictureIndex]
            ? images?.['picture' + pictureIndex]?.fields?.description
            : ''
          : images?.['picture' + pictureIndex]
          ? images?.['picture' + pictureIndex].description
          : '',
        linkText: images?.['linkText' + pictureIndex] ? images?.['linkText' + pictureIndex] : '',
        linkUrl: images?.['linkUrl' + pictureIndex] ? images?.['linkUrl' + pictureIndex] : ''
      });
    }
    return acc;
  }, []);

  const renderImages = () => {
    return groupedImages.map((image, index) => {
      const renderImageTitle = () => {
        const caption = image.caption;
        const linkText = image.linkText;
        const linkUrl = image.linkUrl;
        let formattedTitle = '';

        if (caption || (linkText && linkUrl)) {
          formattedTitle = (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <ImageCaption>
                {caption}
                <ExternalLink
                  linkstyle="secondary-link"
                  style={{ paddingLeft: '5px', fontStyle: 'normal' }}
                  target="_blank"
                  href={linkUrl}
                >
                  {linkText}
                </ExternalLink>
              </ImageCaption>
            </div>
          );
        } else if (caption) {
          formattedTitle = <ImageCaption>{caption}</ImageCaption>;
        }

        return formattedTitle;
      };

      return (
        <ImgContainer onClick={() => onClickHandler(image?.picture)} key={index}>
          <MultiImage src={image?.picture} alt={image?.caption} />
          {renderImageTitle()}
        </ImgContainer>
      );
    });
  };

  return <MultiImageContainer>{renderImages()}</MultiImageContainer>;
};
const ImageCaption = styled.span`
  font-style: italic;
  padding-top: 5px;
  padding-right: 4px;
`;

const MultiImage = styled(props => <img {...props} />)`
  margin: 0;
  padding: 5px;
  max-height: 45vh;
  object-fit: contain;

  @media screen and (max-width: ${media.mediumBottom}) {
    min-width: 70vw;
`;

const ImgContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 45%;
`;

const MultiImageContainer = styled.div`
  cursor: zoom-in;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  max-width: 922px;

  @media screen and (max-width: ${media.mediumBottom}) {
    flex-direction: column;
  }
`;

export default MultiImageSection;
